import { Delete } from "@material-ui/icons";
import { Box, Button, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useMutation, useQueryClient } from "react-query";
import AxiosT from "../../../setup/setup-axios-bearer";
import useBuyFactorStore from "../../../store/into-warehouse/useBuyFactorStore";

const useStyles = makeStyles({
  barcodeItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#fff",
    borderRadius: "11px",
    marginBottom: "10px",
    padding: "8px 12px 8px 8px",
    "& Button": {
      fontSize: "13px",
      color: "#ABACBE",
      "& svg": {
        fontSize: "16px !important",
      },
    },
  },
});

const BarcodeItem = ({ barcode, pdt_id }) => {
  const classes = useStyles();
  const factorID = useBuyFactorStore((store) => store.factorID);
  const queryClient = useQueryClient();
  const { isLoading, mutate, data } = useMutation(
    () =>
      AxiosT.get(`/delete-into-warehouse?id=${factorID}&trace_id=${pdt_id}`),
    {
      onSuccess: (data) => {
        queryClient.resetQueries(["getBarcodeList"]);
      },
    }
  );

  const handleDelete = () => {
    if (barcode) {
      mutate();
    }
  };

  return (
    <Box className={classes.barcodeItem}>
      <Typography variant="h3">{barcode}</Typography>
      <Button startIcon={<Delete />} onClick={handleDelete}>
        حذف
      </Button>
    </Box>
  );
};
export default BarcodeItem;
